import {useEffect, useState} from "react";
import {IMAGE_URL} from "../../path";

interface FourImageGalleryProps {
    id: number;
    image_1: string;
    image_2: string;
    image_3: string;
    image_4: string;
}

function Custom4ImageGalleryComponent(props : FourImageGalleryProps) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const imagePath = IMAGE_URL;

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return <div key={props.id} style={{display: 'flex', flexDirection: windowWidth > 575 ? 'row' : 'column', gap: '16px', marginBottom: '100px', width: '95%', marginLeft: windowWidth > 575 ? 'auto' : '26px', marginRight: windowWidth > 575 ? 'auto' : '0', justifyContent: windowWidth > 575 ? 'space-between' : 'flex-start', alignItems: 'flex-start',}}>
        <div style={{flex: 1}}>
            <img src={imagePath + props.image_1} alt={props.image_1} style={{width: '100%'}} />
        </div>
        <div style={{flex: 1}}>
            <img src={imagePath + props.image_2} alt={props.image_1} style={{width: '100%'}} />
        </div>
        <div style={{flex: 1}}>
            <img src={imagePath + props.image_3} alt={props.image_1} style={{width: '100%'}} />
        </div>
        <div style={{flex: 1}}>
            <img src={imagePath + props.image_4} alt={props.image_1} style={{width: '100%'}} />
        </div>
    </div>
}

export default Custom4ImageGalleryComponent;
